import React from "react";
import { PageHeader } from "./PageHeader";
import logocittru from '../img/organizers/logo-cittru.png';

import pdfInnowacje from '../files/zfp-innowacje.pdf';

export const Innowacje = props => {
    var cittruEmail = 'mailto:katarzyna.malek-zietek@uj.edu.pl';
    var imgStyle = {
        margin: '0 auto'
    }
  return (
    <React.Fragment>
      <PageHeader title="Fizyka - Przemysł - Innowacje" />
      <div className="content-wrapper">
      <div className="sidebar">
              <span className="sidebar-header"> Kontakt</span>
             <p>
                 Katarzyna Małek-Ziętek<br/>
                 Broker CITTRU UJ<br/>
                 e-mail: <a href={cittruEmail}>katarzyna.malek-zietek@uj.edu.pl</a><br/>
                 tel.: +48 519 307 691<br/>
                 <img alt="citru" src={logocittru} style={imgStyle}/>
             </p>
          </div>
        <div className="main-content innowacje">
            <p>
                Szczególną sesją w czasie Zjazdu będzie sesja „Fizyka – Przemysł – Innowacje”.
                Sesja ta organizowana jest przez Centrum Transferu Technologii CITTRU Uniwersytetu Jagiellońskiego
                w ramach działalności ogólnopolskiej sieci Porozumienie Akademickich Centrów Transferów Technologii (PACTT).
                Sesja ta poświęcona będzie współpracy
                nauka-przemysł, nastawionej na rozwijanie i wdrażanie innowacyjnych technologii. Sesja składać się będzie
                z wystąpień pracowników naukowych uczelni i osób prowadzących działalność badawczo-rozwojową w
                przedsiębiorstwach. Będzie również okazją do prezentacji przez firmy swoich osiągnięć i najnowszej oferty
                wykorzystującej zaawansowane technologie i/lub skierowanej do badaczy-eksperymentatorów.
                To dwudniowe wydarzenie odbędzie się  16 i 17 września 2019 roku.
            </p>
            <p>Zapisy na sesję, wraz z możliwością nadsyłania zgłoszeń (abstraktów) do wystąpień, rozpoczną się w marcu 2019 wraz z otwarciem rejestracji dla wszystkich uczestników Zjazdu.</p>
            <p>
                Wiecej szczegółów można odnaleźć w naszej ulotce:
                <a href={pdfInnowacje}>&nbsp;PDF</a>
            </p>
        </div>
          
      </div>
    </React.Fragment>
  );
};

Innowacje.propTypes = {};
